export const CHANGE_FILTERS_SUCCESS = 'CHANGE_FILTERS_SUCCESS';
export const RESET_FILTERS_SUCCESS = 'RESET_FILTERS_SUCCESS';
